module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.site) ? _c('div', {
    staticClass: "video-background",
    class: {
      'blurred': _vm.blur && _vm.blurEnabled
    }
  }, [_c('transition', {
    attrs: {
      "name": "fadeinplace"
    }
  }, [(_vm.showSlideshow) ? _c('slideshow', {
    attrs: {
      "srcs": _vm.stills
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeinplace"
    }
  }, [_c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showSlideshow),
      expression: "!showSlideshow"
    }],
    attrs: {
      "src": _vm.src,
      "muted": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    },
    on: {
      "playing": function($event) {
        return _vm.$emit('playing')
      }
    }
  })])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44d05e26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoBackground.vue
// module id = 383
// module chunks = 1